import { init } from './MallCPASSItems';
init();
